module.exports = __webpack_public_path__ + "img/recomanda.57a93092.svg";